import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function selfServiceReducer() {
    return combineReducers({
        SelfServiceFrame_SimpleList: createItemReducer("SelfService", "SelfServiceFrame.SimpleList", false),
        SelfServiceFrame_PrelimInfo1: createItemReducer("SelfService", "SelfServiceFrame.PrelimInfo1", false),
        SelfServiceFrame_PrelimInfo1_Params: createItemReducerParams("SelfService", "SelfServiceFrame.PrelimInfo1"),
        SelfServiceFrame_PrelimInfo2: createItemReducer("SelfService", "SelfServiceFrame.PrelimInfo2", false),
        SelfServiceFrame_PrelimInfo3: createItemReducer("SelfService", "SelfServiceFrame.PrelimInfo3", false),
        SelfServiceFrame_CheckAndSendData: createItemReducer("SelfService", "SelfServiceFrame.CheckAndSendData", false),

        //ReceiveSysDoc_TreeDocForPOParams: createItemReducerParams("ReceiveSysDoc", "ReceiveSysDoc.TreeDocForPO"),
    });
}